import React, { createRef } from 'react';
import { IconButton, makeStyles, SvgIcon } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Modal, Col } from 'react-bootstrap';
import HealthClassPopUpContent from './HealthClassPopUp/HealthClassPopUpContent';
import CoverageAmountPopUpContent from './CoverageAmountPopUp/CoverageAmountPopUpContent';
import CoverageLengthPopUpContent from './CoverageLengthPopUp/CoverageLengthPopUpContent';
import PrintOutlinedIcon from '@material-ui/icons/PrintOutlined';
import { useReactToPrint } from 'react-to-print';
import './PopUps.scss';

const useStyles = makeStyles((theme) => ({
    blueText : {
        color: theme.palette.primary.main,
        cursor:'pointer',
        marginTop:'10px'
    }
}));

export default function PopUpIntro(props) {
    const classes = useStyles();
    const { show, onHide, modalClasses, onFieldChange, onCoverageAmountChange } = props;
    const printRef = createRef();
    const handlePrint = useReactToPrint({
        copyStyles: true,
        content: () => printRef.current,
    })

    return (
        <Modal className={`${modalClasses || ''}`} show={show} onHide={onHide} animation={false} centered size='lg'>
                {
                    props.field !== 'term' &&
                    <div onClick={handlePrint} className={classes.blueText} ><SvgIcon component={PrintOutlinedIcon} className='ml-3 my-2'/> <b>Print Page</b></div>
                }
            <Modal.Header className={`${props.field !== 'term'?'py-0':'pb-0'}`} ref={printRef}>
                <Modal.Title>Help Me Decide: {props.heading}</Modal.Title>
                <IconButton className={`close-button ${props.field !== 'term'?'button-margin':''} `} aria-label="close" onClick={onHide}>
                    <CloseIcon />
                </IconButton>
            </Modal.Header>
            <Modal.Body>
                <Col>
                    <p className='pt-1' dangerouslySetInnerHTML={{ __html: props.details }}></p>
                    {
                        props.field === 'healthClass' ?
                            <HealthClassPopUpContent heading={props.heading} details={props.details} ref={printRef} onHide={onHide} onFieldChange={onFieldChange} />
                            :
                            props.field === 'coverageAmount' ?
                                <CoverageAmountPopUpContent heading={props.heading} details={props.details} ref={printRef} onHide={onHide} onFieldChange={onCoverageAmountChange} />
                                :
                                <CoverageLengthPopUpContent onHide={onHide} onFieldChange={onFieldChange} />
                    }
                </Col>
            </Modal.Body>
        </Modal>
    )
}


// WEBPACK FOOTER //
// ./src/components/Product/TermLifeInsurance/PopUps/PopUpIntro.js